import service from "@/api/service";
import { GetResponse } from "@/api/common/coupon-list/response";
import { GetRequest } from "@/api/common/coupon-list/request";

/**
 * クーポン情報取得APIをコールします。
 *
 * @return GetResponse
 */
export async function searchCoupon(getRequest: GetRequest) {
  const response = await service.post("/common-get-coupon-list", getRequest);
  return response.data as GetResponse;
}
